<template>
<div class="credit_info rr">有効期限 <span class="expired_date rr">{{ expireYearMonth }}</span> <span v-if="expired" class="expired">有効期限切れ</span></div>
</template>

<script>
export default {
  props: ['expired', 'expireYearMonth'],
}
</script>

<style lang="css" scoped>
.credit_info {
  font-size: 10px;
  width: 100%;
}
.expired {
  color: #FF0000;
  font-size: 10px;
}
.expired_date {
  font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/CreditcardExpired.vue